<template>
  <FilterParent
    class="primary"
    module="Emergency Order Container"
    maxWidth="600"
    v-model="showFilterDialog"
  >
    <template #filterContent>
      <v-row class="ma-0">
        <v-col cols="6" class="pa-2">
          <MultiSelect
            label="Status"
            :items="statusList"
            itemText="text"
            itemValue="value"
            clearable
            hide-details="auto"
            v-model="filterObject.status"
          />
        </v-col>
        <v-col cols="6" class="pa-2">
          <Autocomplete
            label="Origin"
            :loading="originLoading"
            :totalItems="originCount"
            :items="originList"
            itemText="name"
            itemValue="id"
            @updateList="$emit('getOriginList', $event)"
            v-model="selectedOrigin"
          />
        </v-col>
        <v-col cols="6" class="pa-2">
          <Autocomplete
            label="Destination"
            :loading="destinationLoading"
            :totalItems="destinationCount"
            :items="destinationList"
            itemText="name"
            itemValue="id"
            @updateList="$emit('getDestinationList', $event)"
            v-model="selectedDestination"
          />
        </v-col>
        <v-col cols="6" class="pa-2">
          <Autocomplete
            label="Vendor"
            :loading="vendorLoading"
            :totalItems="vendorCount"
            :items="vendorList"
            itemText="company_name"
            itemValue="id"
            @updateList="$emit('getVendorList', $event)"
            v-model="selectedVendor"
          />
        </v-col>
        <v-col cols="6" class="pa-2">
          <DateField
            :inputProps="{
              dense: true,
              label: 'Movement Date',
              'hide-details': 'auto',
              clearable: true,
            }"
            v-model="filterObject.movement_date"
          />
        </v-col>
        <v-col cols="6" class="pa-2">
          <DateField
            :inputProps="{
              dense: true,
              label: 'Completed On',
              'hide-details': 'auto',
              clearable: true,
            }"
            v-model="filterObject.completed_on"
          />
        </v-col>
        <v-col cols="6" class="pa-2">
          <v-text-field
            label="Failure Reason"
            outlined
            dense
            clearable
            hide-details="auto"
            v-model="filterObject.failure_reason"
          />
        </v-col>
        <v-col cols="6" class="pa-2">
          <DateField
            :inputProps="{
              dense: true,
              label: 'Sub Hire Creation Date',
              'hide-details': 'auto',
              clearable: true,
            }"
            v-model="filterObject.subhire_created_date"
          />
        </v-col>
      </v-row>
    </template>

    <template #filterAction>
      <v-btn
        color="secondary"
        depressed
        @click="
          $emit('resetFilters');
          showFilterDialog = false;
        "
      >
        Reset
      </v-btn>
      <v-btn
        color="primary"
        class="ml-2"
        depressed
        @click="
          $emit('applyFilters');
          showFilterDialog = false;
        "
      >
        Apply
      </v-btn>
    </template>
  </FilterParent>
</template>

<script>
import FilterParent from "@/components/General/FilterParent.vue";
import MultiSelect from "@/components/FormBaseComponents/MultiSelect.vue";
import Autocomplete from "@/components/FormBaseComponents/Autocomplete.vue";
import DateField from "@/components/FormBaseComponents/DateField.vue";

export default {
  components: {
    FilterParent,
    MultiSelect,
    Autocomplete,
    DateField,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    bindingObject: {
      type: Object,
      default: () => ({}),
    },
    originList: {
      type: Array,
      default: () => [],
    },
    originCount: {
      type: Number,
      default: 0,
    },
    originLoading: {
      type: Boolean,
      default: false,
    },
    destinationList: {
      type: Array,
      default: () => [],
    },
    destinationCount: {
      type: Number,
      default: 0,
    },
    destinationLoading: {
      type: Boolean,
      default: false,
    },
    selectedOriginObj: {
      type: Object,
      default: null,
    },
    selectedDestinationObj: {
      type: Object,
      default: null,
    },
    vendorList: {
      type: Array,
      default: () => [],
    },
    vendorCount: {
      type: Number,
      default: 0,
    },
    vendorLoading: {
      type: Boolean,
      default: false,
    },
    selectedVendorObj: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      statusList: [
        { text: "Pending", value: "Pending" },
        { text: "Active", value: "Active" },
        { text: "Completed", value: "Completed" },
        { text: "Cancelled", value: "Cancelled" },
      ],
    };
  },
  computed: {
    showFilterDialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    filterObject: {
      get() {
        return this.bindingObject;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    selectedOrigin: {
      get() {
        return this.selectedOriginObj;
      },
      set(val) {
        this.$emit("update:selectedOriginObj", val);
      },
    },
    selectedDestination: {
      get() {
        return this.selectedDestinationObj;
      },
      set(val) {
        this.$emit("update:selectedDestinationObj", val);
      },
    },
    selectedVendor: {
      get() {
        return this.selectedVendorObj;
      },
      set(val) {
        this.$emit("update:selectedVendorObj", val);
      },
    },
  },
};
</script>
